import { memo } from "react";

/**
 * Renders a short content string that may contain a limited set of inline HTML
 * tags (specifically <em>, <br>, and <strong>) from the CMS. These exist in the
 * original markup and map directly to the typographic design (italic accent
 * colors, line breaks inside display headings). All other HTML is stripped
 * before rendering to keep the surface safe.
 */
function sanitize(html: string): string {
  // Keep only <em>, </em>, <br>, <br/>, <br />, <strong>, </strong>
  return html.replace(/<(?!\/?(em|br|strong)(\s*\/?)?>)[^>]+>/gi, "");
}

type Tag = keyof JSX.IntrinsicElements;

interface RichProps {
  as?: Tag;
  html: string;
  className?: string;
}

function RichTextBase({ as, html, className }: RichProps) {
  const Tag = (as ?? "span") as keyof JSX.IntrinsicElements;
  const props: Record<string, unknown> = {
    className,
    dangerouslySetInnerHTML: { __html: sanitize(html) },
  };
  return <Tag {...props} />;
}

export const RichText = memo(RichTextBase);
